import AnalyticsWebClient from '@atlassiansox/analytics-web-client';
import { fg } from '@atlaskit/platform-feature-flags';
export var isSSR = function isSSR() {
  var isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
  var isMissingBooleanFF = !fg;
  var isMissingAnalyticsWebClient = !Boolean(AnalyticsWebClient);
  if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) {
    return true;
  } else {
    return false;
  }
};